import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { getThemes } from '../../../stylesheets/themes';

const Theming = ({ defaultTheme, globalTheme, siteTheme, baseFontSize = 100, children }) => {
  // Check if global and site theme are in data and check if value exists in themes object
  const themeObject = defaultTheme
    ? getThemes(parseInt(baseFontSize, 10))
    : getThemes(parseInt(baseFontSize, 10), globalTheme, siteTheme || globalTheme);

  return (
    <ThemeProvider theme={themeObject}>
      <>{children}</>
    </ThemeProvider>
  );
};

Theming.propTypes = {
  defaultTheme: PropTypes.bool.isRequired,
  globalTheme: PropTypes.string.isRequired,
  siteTheme: PropTypes.string,
  baseFontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node
};

const mapStateToProps = ({ app, accessibility }) => {
  return {
    defaultTheme: accessibility.defaultTheme,
    globalTheme: app.pageData.globalTheme || 'default',
    siteTheme: app.pageData.siteTheme,
    baseFontSize: accessibility.baseFontSize
  };
};
export default connect(mapStateToProps)(Theming);
